module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_yosoplus-27975477e8477954a2891040d49a8a8f.jpg";